class UsefulPagesSearch extends HTMLElement {
  constructor() {
    super();
    this.searchInput = null;
    this.searchBtn = null;
    this.noResultsMessage = null;
    this.usefulPagesCards = [];
    this.mainContent = null;
    this.sectionsToHide = [];
    this.contactPageDivs = [];
    this.init();
  }

  connectedCallback() {
    this.initializeElements();
    this.attachEventListeners();
  }

  init() {
    // Create the search form structure
    this.innerHTML = `
      <div class="help-search">
        <h2>How Can We Help?</h2>
        <div class="search-container">
          <div class="search-box">
            <input 
              id="useful-pages-search-input"
              type="text" 
              placeholder="Search" 
              aria-label="Search"
              autocomplete="off">
            <button type="button" id="useful-pages-search-btn" aria-label="Search">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 14L10.1 10.1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  initializeElements() {
    this.searchInput = this.querySelector('#useful-pages-search-input');
    this.searchBtn = this.querySelector('#useful-pages-search-btn');

    // Find all useful pages cards in the document
    this.usefulPagesCards = document.querySelectorAll('.useful-pages-card');

    // Find or create no results message in useful-pages-section
    this.usefulPagesSection = document.querySelector('.useful-pages-section');
    if (this.usefulPagesSection) {
      // Check if no results message already exists
      this.noResultsMessage = this.usefulPagesSection.querySelector('#no-results-message');
      if (!this.noResultsMessage) {
        // Create no results message in useful-pages-section
        this.noResultsMessage = document.createElement('div');
        this.noResultsMessage.id = 'no-results-message';
        this.noResultsMessage.className = 'no-results-message';
        this.noResultsMessage.style.display = 'none';
        this.noResultsMessage.innerHTML = '<p>No items found matching your search.</p>';
        this.usefulPagesSection.appendChild(this.noResultsMessage);
      }
    }

    // Find MainContent and sections to hide
    this.mainContent = document.getElementById('MainContent');
    if (this.mainContent) {
      this.sectionsToHide = Array.from(this.mainContent.querySelectorAll('section')).filter(
        (section) => {
          return (
            !section.classList.contains('useful-pages-section') &&
            !section.classList.contains('windowScroller') &&
            !section.classList.contains('hero-center-header') &&
            !section.closest('.hero-center-header') && // Also exclude if it's inside hero-center-header
            !section.querySelector('.contact-page-main-content')
          ); // Exclude sections containing contact-page-main-content
        }
      );

      // Also find and hide divs with contact-page-main-content class
      this.contactPageDivs = Array.from(
        this.mainContent.querySelectorAll('.contact-page-main-content')
      );
    }
  }

  attachEventListeners() {
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.performSearch());
      this.searchInput.addEventListener('keyup', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.performSearch();
        }
      });
    }

    if (this.searchBtn) {
      this.searchBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.performSearch();
      });
    }
  }

  performSearch() {
    const searchTerm = this.searchInput.value.toLowerCase().trim();
    let hasResults = false;

    this.usefulPagesCards.forEach((card) => {
      const titleElement = card.querySelector('.useful-pages-card-title');
      if (titleElement) {
        const titleText = titleElement.textContent.toLowerCase();

        // Check if search term matches (partial match)
        if (searchTerm === '' || titleText.includes(searchTerm)) {
          card.classList.remove('hidden');
          hasResults = true;
        } else {
          card.classList.add('hidden');
        }
      }
    });

    // Show/hide no results message
    if (searchTerm !== '' && !hasResults) {
      this.noResultsMessage.style.display = 'block';
    } else {
      this.noResultsMessage.style.display = 'none';
    }

    // Hide/show sections based on search state
    this.toggleSectionsVisibility(searchTerm !== '');
  }

  // Public method to reset search
  resetSearch() {
    if (this.searchInput) {
      this.searchInput.value = '';
      this.performSearch();
    }
  }

  // Public method to set search term
  setSearchTerm(term) {
    if (this.searchInput) {
      this.searchInput.value = term;
      this.performSearch();
    }
  }

  // Method to toggle sections visibility based on search state
  toggleSectionsVisibility(isSearchActive) {
    if (!this.sectionsToHide || this.sectionsToHide.length === 0) return;

    this.sectionsToHide.forEach((section) => {
      if (isSearchActive) {
        // Hide sections when search is active
        section.style.display = 'none';
        section.setAttribute('data-hidden-by-search', 'true');
      } else {
        // Show sections when search is not active
        section.style.display = '';
        section.removeAttribute('data-hidden-by-search');
      }
    });

    // Also handle contact-page-main-content divs
    if (this.contactPageDivs && this.contactPageDivs.length > 0) {
      this.contactPageDivs.forEach((div) => {
        if (isSearchActive) {
          // Hide contact page divs when search is active
          div.style.display = 'none';
          div.setAttribute('data-hidden-by-search', 'true');
        } else {
          // Show contact page divs when search is not active
          div.style.display = '';
          div.removeAttribute('data-hidden-by-search');
        }
      });
    }
  }
}

// Register the custom element
customElements.define('useful-pages-search', UsefulPagesSearch);
